
import {isEmpty, isNil } from "lodash";
import { useCallback, useEffect, useRef, useState } from "react";
import Webcam from "react-webcam";
import "../../css/videoComponent.css";
import DeleteIcon from "../../assets/images/DeleteIcon.png";
import RecordVideoIcon from "../../assets/images/RecordVideoIcon.png";
import UploadVideoIcon from "../../assets/images/UploadVideoIcon.png";
import { useUploadImageMutation } from "../../store/appSlice";
import { RingLoader } from "react-spinners";
import WebcamComponent from "./WebcamComponent";
import Logo from "../../assets/images/01hire-logo.svg";


interface WebcamVideoProps {
  // Add any additional props for the component
  onSelectVideo:(data:string)=>void;
  incomingVideoUrl:string|null;
  isEdit?:boolean;
  fromProfile?:boolean
}

const VideoRecorderComponent: React.FC<WebcamVideoProps> = (props) => {
  const{onSelectVideo,incomingVideoUrl,isEdit,fromProfile}=props
  console.log({incomingVideoUrl})

  const webcamRef = useRef<Webcam>(null);
  const mediaRecorderRef = useRef<MediaRecorder | null>(null);
  const [showWebcamModal, setShowWebcamModal] = useState(false);
  const [recordingVideo,setRecordingVideo]=useState(false)
  const [uploadingVideo,setUploadingVideo]=useState(false)
  const [isVideoRecorded, setVideoRecorded] = useState(false);
  const [recordedChunks, setRecordedChunks] = useState<Blob[]>([]);
  const [previewSrc, setPreviewSrc] = useState<string | null>(incomingVideoUrl);
  const uploadRef=useRef<any>()

  const [uploadImage] = useUploadImageMutation();


useEffect(()=>{
  setPreviewSrc(incomingVideoUrl)
},[incomingVideoUrl])


  const requestUserMedia = async () => {
    try {
      const stream = await navigator.mediaDevices.getUserMedia({
        video: true, // Request access to the camera
        audio: true, // Request access to the microphone
      });
      // If the user grants access, set the stream to the webcam reference
      if (webcamRef?.current && webcamRef?.current?.video) {
        console.log("inside new")
        webcamRef.current.video.srcObject = stream;
      }
    } catch (err) {
      // Handle any errors or permission denials
      console.error('Error accessing media devices:', err);
    }
  };

 
  const onVideoUpload=(blobData:any)=>{
    setUploadingVideo(true)
    const formData = new FormData()
    formData.append("file", blobData);
    
    uploadImage(formData)
    .unwrap()
    .then((data) => {
    onSelectVideo(data?.url)
    setUploadingVideo(false)
    })
    .catch((err) => {
      setUploadingVideo(false)

    });
  }

  const handleDataAvailable = useCallback(
    ({ data }: { data: BlobEvent["data"] }) => {
      console.log("inside data available")
      if (data.size > 0) {
        setRecordedChunks((prev) => prev.concat(data as Blob));
      }
    },
    [setRecordedChunks]
  );

  const updatePreview = () => {
    if (recordedChunks.length) {
      const blob = new Blob(recordedChunks, {
        type: "video/mp4",
      });
      onVideoUpload(blob)
      const url = URL.createObjectURL(blob);
      console.log({url})
      setPreviewSrc(url);
    }
    
  };

  useEffect(() => {
    if(isVideoRecorded){
    updatePreview();
    }
  }, [recordedChunks]);


  const handleStartRecording = useCallback(() => {
    setRecordingVideo(true)
    setRecordedChunks([]);
    if (webcamRef.current) {
      mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream as MediaStream, {
        mimeType: "video/webm",
      });
      console.log({mediaRecorderRefStart:mediaRecorderRef})
      mediaRecorderRef.current.addEventListener(
        "dataavailable",
        handleDataAvailable
      );
      mediaRecorderRef.current.start();
    }

  }, [webcamRef,mediaRecorderRef,setShowWebcamModal, handleDataAvailable]);



  const handleStopRecording = useCallback(() => {
    setRecordingVideo(false)
    setShowWebcamModal(false)

    if (mediaRecorderRef.current) {
      console.log('inside')

      mediaRecorderRef.current.stop();
      
    }

  }, [mediaRecorderRef,setShowWebcamModal]);


  const handleUploadBtnClick = () => {
    uploadRef.current.click();
  };

  const onCloseCamera = async () => {
    if (webcamRef?.current && webcamRef?.current?.video) {
      const videoElement = webcamRef.current.video;
  
      if (videoElement.srcObject instanceof MediaStream) {
        const tracks = videoElement.srcObject.getTracks();
    
        if (tracks.length > 0) {
          const stopPromises = tracks.map(track => track.stop());
  
          try {
            await Promise.all(stopPromises);
            videoElement.srcObject=null
            console.log('All tracks stopped successfully.');
          } catch (error) {
            console.error('Error stopping tracks:', error);
          }
        }
      }
    }
  };

  const onUploadImageFromGallery=(e:any)=>{
    if (e.target.files && e.target.files.length > 0) {
      const blob = new Blob([e.target.files[0]], {
        type: "video/mp4",
      });
      onVideoUpload(e?.target?.files[0])
      const url = URL.createObjectURL(blob);
      setPreviewSrc(url);
    }
  }


  const onCloseWebcam=()=>{
    setVideoRecorded(false)
    onCloseCamera()
    setRecordedChunks([]);
    setRecordingVideo(false)
    setShowWebcamModal(false)
  }

  return (
    <>

    <div className="videoComponentContainer">
<div>
   <input
        type="file"
        accept="video/mp4"
        ref={uploadRef}
        style={{ display: 'none' }}
        onChange={(e)=>{
          onUploadImageFromGallery(e)
        }}
      />

{!isNil(previewSrc) && !isEmpty(previewSrc) && !uploadingVideo &&(<div className="alignVideoComponentCenter introductory_video_container">
  <div className="introductory_video_content">

     <iframe
height="270"
width="340"
src={previewSrc!}
allowFullScreen
style={{borderRadius:10,resize:'vertical'}}
/> 
<div style={{marginTop:-52,width:'99.5%',backgroundColor:'#A8A9AD',alignItems:"center",display:'flex',justifyContent:'center',height:52,borderBottomLeftRadius:10,borderBottomRightRadius:10,marginRight:2}}>
<img src={Logo} style={{width:90,height:90}}/>
</div>

  </div>
</div>
)}

{uploadingVideo && isEdit &&(
  <div className="alignVideoComponentCenter">
 <RingLoader
 loading={uploadingVideo && isEdit}
 aria-label="Loading Spinner"
 data-testid="loader"
/>
</div>
)}


{isEdit && !uploadingVideo &&(<div style={{flexDirection:'row',display:'flex',alignItems:'center'}}>
      <div style={{flexDirection:'row',display:'flex',justifyContent:'center',marginRight:fromProfile?140:0}}>
        <button className="introductory_video_sec_btns" style={{marginRight:10}} onClick={handleUploadBtnClick}>
           <img src={UploadVideoIcon} style={{width:18,height:18}}/>
          <h4 style={{color:'white',fontSize:14,marginTop:6,marginLeft:7}}>Upload Video</h4></button>

        <button className="introductory_video_sec_btns" onClick={()=>{
            setShowWebcamModal(true)
        }}>
          <img src={RecordVideoIcon} style={{width:18,height:18}}/>
          <h4 style={{color:'white',fontSize:14,marginTop:6,marginLeft:7}}>Record Video</h4>
          </button>
     </div>
     {!isNil(previewSrc) && !isEmpty(previewSrc) && <div onClick={()=>{
          setPreviewSrc(null);
          setRecordedChunks([])
          onSelectVideo('')
   }} style={{cursor:'pointer'}}><img src={DeleteIcon} style={{width:25,height:25,marginTop:7,marginLeft:10}}/></div>}
     </div>)}
     </div>

     </div>

 {showWebcamModal &&<WebcamComponent showWebcamModal={showWebcamModal} onCloseWebcam={onCloseWebcam} 
 onCloseCamera={onCloseCamera} recordingVideo={recordingVideo} 
 handleStopRecording={handleStopRecording} 
 handleStartRecording={()=>{
  setVideoRecorded(true)
  handleStartRecording()
}} 
 webcamRef={webcamRef}/>
}


</>
  );
};

export default VideoRecorderComponent;

